import { useQuery } from '@tanstack/react-query';

import { fetchChargeHistory } from '../charge-history';

export const useChargeHistory = (params: any) => {
  return useQuery(['charge-history'], () => fetchChargeHistory(params), {
    enabled: false
  });
};
